import { useUser } from 'context/useUser'
export function useVerifyUser(){
  const {user} = useUser();
  const userLocal = JSON.parse(localStorage.getItem("userSession"));
  console.log(userLocal, "local")
  return (userLocal || user)
}
